export default "__VITE_ASSET__DiNg20DR__"